import React, { useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Box, useMediaQuery, useTheme } from "@mui/material";
import { NavBar, Sidebar, Notification, AdminSidebar } from "./components";
import { useSelector } from "react-redux";
import { userRoles } from "./common/constant/index.js";
import theme from "../src/common/theme/theme";

const Layout = ({ children }) => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        {/* Navigation Bar */}
        <NavBarWrapper handleDrawerToggle={handleDrawerToggle} />

        {/* Sidebar and Main Content */}
        <Box sx={{ display: "flex", flexGrow: 1, mt: { xs: 0, md: 0 } }}>
          <SideBarWrapper
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
          />

          {/* Main Content Area */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: { xs: 1, sm: 2, md: 3 },
              mt: { xs: 7, md: 8 },
              width: { xs: "100%", md: `calc(100% - ${isMobile ? 0 : 240}px)` },
              overflow: "auto",
            }}
          >
            <Notification />
            {children}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

const NavBarWrapper = ({ handleDrawerToggle }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  return isLoggedIn ? <NavBar handleDrawerToggle={handleDrawerToggle} /> : null;
};

const SideBarWrapper = ({ mobileOpen, handleDrawerToggle }) => {
  const { isLoggedIn, role } = useSelector((state) => state.auth);

  if (!isLoggedIn) return null;

  // Check the role and render the appropriate sidebar
  if (role === userRoles.SUPER_ADMIN) {
    return (
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
    );
  } else if (role === userRoles.ADMIN) {
    return (
      <AdminSidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
    );
  }

  return null;
};

export default Layout;
